<template>
  <div>
    <div id="home" class="bg-secondary">
      <div class="container py-md-5 home__container">
        <div class="row py-5 d-flex align-items-center h-100">
          <div class="col-12 col-md-5 order-2 order-md-1 px-4 px-md-0">
            <h1 class="fw-bolder">{{ $t('home.header') }}</h1>
            <p class="mt-3 text-muted">{{ $t('home.subheader') }}</p>
            <a class="mt-3" :href="`/${$i18n.locale}/#products`">
              <button class="btn btn-primary rounded-pill px-4 py-3 text-uppercase">{{ $t('home.button') }}</button>
            </a>
          </div>
          <div class="col-12 col-md-7 order-1 order-md-2 pb-5 pb-md-0 d-flex">
            <img :src="require('@/assets/start-image.jpg')" alt="Juice" class="home__image"/>
          </div>
        </div>
      </div>
      <div class="home__partners">
        <p class="h6 text-light fw-bold text-uppercase my-3">{{ $t('home.partners') }}</p>
        <div class="row home__partners--row">
          <div class="col-12 col-sm-5 col-md-4 d-flex justify-content-center px-4">
            <a href="https://www.sunprod.it/"><img :src="require('@/assets/partners/sunprod.png')" height="100" class="mx-2" alt="Sunprod" /></a>
          </div>
          <div class="col-12 col-sm-3 col-md-4 d-flex justify-content-center px-4">
            <img :src="require('@/assets/partners/kerinfo.png')" height="100" class="mx-2" alt="Kerinfo"/>
          </div>
          <div class="col-12 col-sm-4 d-flex justify-content-center px-4">
            <a href="https://abalt.lt/imone/303321740"><img :src="require('@/assets/partners/abalt.png')" height="125" class="mx-2" alt="Abalt"/></a>
          </div>
        </div>
      </div>
    </div>
    <s_about></s_about>
    <s_products></s_products>
    <s_contact></s_contact>
    <s_footer></s_footer>
  </div>
</template>

<script>
import about_section from "../components/About";
import products_section from "../components/Products";
import contact_section from "../components/Contact";
import footer_section from "../components/Footer";

export default {
  name: 'Home',
  components: {
    's_about': about_section,
    's_products': products_section,
    's_contact': contact_section,
    's_footer': footer_section
  },
}
</script>

<style scoped>
#home {
  padding-top: 71px;
}

.home__container {
  margin: 50px auto 50px auto;
}

.home__image {
  border-radius: 120% 59% 100% 85%;
  width: 100%;
  object-fit: cover;
}

.home__partners {
  background-color: #227b5d;
  min-height: 150px;
  width: 100%;
  display: grid;
  justify-items: center;
}

.home__partners--row {
  width: 100%;
}
</style>
